import Request from '../data/request'

import ApiDocument from "../api/document"
import Task from "../../model2/task/task"
import ProjectUser from "../../model2/project-user/project-user";

const debug = false
// const debug = "MoveManager"

export default class MoveManager {

    //static MAX_NESTED_PROJECTS = 3;

    static setTaskSortPosition(taskId:ID, sortPosition:number) {
        return new Request(this,'PUT','task/'+taskId+'/sort',{
            sortPosition: sortPosition
        });
    }

    static setProjectSortPosition(projectId:ID, sortPosition:number) {
        return new Request(this,'PUT','project/'+projectId+'/sort',{
            sortPosition: sortPosition
        });
    }

    static moveTaskToProject(taskId:ID, toProjectId:ID, arrTaskUsers:any[], onDoneCallback?:callback) {
        MoveManager.moveAndSortTaskToProject(taskId, toProjectId, arrTaskUsers, null, onDoneCallback)
    }

    static async moveAndSortTaskToProject(taskId:ID, toProjectId:ID, arrTaskUsers:any[], sortPosition:number|null|undefined, onDoneCallback?:callback) {

        // let's first deal with users ....

        // find task users who are not in destinationProject
        const destinationProjectUsers = gd.session.projectUsers.filterByProject(toProjectId).map((pu:ProjectUser)=>{return pu.user.id});
        const usersToAdd : any[] = [];

        if (_.isEmpty(arrTaskUsers)) {
            debug && console.log(debug, 'moveAndSortTaskToProject: no arrTaskUsers')
            // @ts-ignore
            const task = await Task.initById(taskId, {taskUsers: true})
            if (task) {
                arrTaskUsers = _.map(task.users, tu=>tu.userId)
            }
        }

        _.map(arrTaskUsers, userId=>{
            if (!destinationProjectUsers.includes(userId)) usersToAdd.push(userId);
        });

        debug && console.log(debug, 'moveAndSortTaskToProject usersToAdd', usersToAdd, arrTaskUsers)

        // find original project access for missing users ?? well no - we do it on backend

        // do move
        const moveRequest = new Request(this, 'put', 'task/'+taskId+'/move-to-project', {
            projectId: toProjectId,
            newProjectUsers: usersToAdd,
            sortPosition: sortPosition
        });

        moveRequest.done(response=>{
            if (onDoneCallback) onDoneCallback(response);
        });

        return moveRequest;
    }

    static moveTaskToTask(taskId:ID, toTaskId:ID, onDoneCallback:callback) {

        const moveRequest = new Request(this, 'put', 'task/'+taskId+'/move-to-task', {
            parentTaskId: toTaskId
        });

        moveRequest.done(response=>{
            if (onDoneCallback) onDoneCallback(response);
        });
    }

    static moveAndSortTaskToTask(taskId:ID, toTaskId:ID, sortPosition:number, onDoneCallback?:callback) {

        const moveRequest = new Request(this, 'put', 'task/'+taskId+'/move-to-task', {
            parentTaskId: toTaskId,
            sortPosition: sortPosition
        });

        moveRequest.done(response=>{
            if (onDoneCallback) onDoneCallback(response);
        });
    }


    static moveProjectToProject(projectId:ID, toProjectId:ID, onDoneCallback:callback) {
        MoveManager.moveAndSortProjectToProject(projectId, toProjectId, null, onDoneCallback)
    }

    static moveAndSortProjectToProject(projectId:ID, toProjectId:ID|null, sortPosition:number|null|undefined, onDoneCallback?:callback) {

        // do move
        const moveRequest = new Request(this,'PUT','project/'+projectId+'/move',{
            parentId: toProjectId,
            sortPosition: sortPosition
        });

        moveRequest.done(response=>{
            if (onDoneCallback) onDoneCallback(response);
        });

    }

    static moveMultiToProject(arrTasks:ID[], arrProjects:ID[], toProjectId:ID, onDoneCallback:callback) {

        // build list of commands
        const serialActions : any[] = []
        if (arrProjects && arrProjects.length>0) {
            serialActions.push( {action: "moveProject", ids: arrProjects} )
        }

        if (arrTasks && arrTasks.length>0) {
            serialActions.push( {action: "moveTasks", ids: arrTasks} )
        }

        const sequenceAction = (pos:any, addNextCall:any)=>{
            const sa = serialActions[pos];
            let request;
            if (sa) {
                switch(sa.action){
                    case "moveTasks":   request = gd.api.BulkActions.moveTasksToProject(sa.ids, toProjectId); break;
                    case "moveProject": request = gd.api.BulkActions.moveProjectsToProject(sa.ids, toProjectId); break;
                }

                request.done((data:any)=>{addNextCall(++pos)});
                request.fail((error:any)=>{
                    gd.apiError(error);
                    addNextCall(++pos);
                });
            } else {
                onDoneCallback(null);
            }
        };

        const serialMove = (pos=0)=>{sequenceAction(pos, serialMove);};
        serialMove();
    }

    static moveNoteToProject(noteId:ID, toProjectId:ID, arrTaskUsers:any[], onDoneCallback:callback) {
        MoveManager.moveAndSortNoteToProject(noteId, toProjectId, arrTaskUsers, null, onDoneCallback)
    }

    static moveAndSortNoteToProject(noteId:ID, toProjectId:ID, arrTaskUsers:any[], sortPosition:number|null, onDoneCallback:callback) {
        // let's first deal with users ....

        // find task users who are not in destinationProject
        const destinationProjectUsers = gd.session.projectUsers.filterByProject(toProjectId).map((pu:ProjectUser)=>pu.user.id);
        const usersToAdd = [];

        arrTaskUsers.map(userId=>{
            if (!destinationProjectUsers.includes(userId)) usersToAdd.push(userId);
        });

        // find original project access for missing users ?? well no - we do it on backend

        // do move
        // const request = Api.Wiki.noteMove(noteId, toProjectId);
        const request = ApiDocument.move(noteId, toProjectId);

        request.done(response=>{
            if (onDoneCallback) onDoneCallback(response);
        });

    }

    static moveMeetingToProject(meetingId:ID, toProjectId:ID, onDoneCallback:callback) {
        /*// let's first deal with users ....

        // find task users who are not in destinationProject
        const destinationProjectUsers = gd.session.projectUsers.filterByProject(toProjectId).map(pu=>{return pu.user.id});
        const usersToAdd = [];

        arrTaskUsers.map(userId=>{
            if (!destinationProjectUsers.includes(userId)) usersToAdd.push(userId);
        });*/

        // do move
        const moveRequest = gd.api.Meeting.meetingUpdate(meetingId, {
            projectId: toProjectId
        });

        moveRequest.done((response:any)=>{
            if (onDoneCallback) onDoneCallback(response);
        });

        return moveRequest;

    }

    static moveEventToProject(eventId:ID, fromProjectId:ID|null, toProjectId:ID|null, onDoneCallback?:callback) {
        if(!toProjectId) return

        // do move
        const moveRequest = gd.api.Events.setProjectId(eventId, toProjectId)

        moveRequest.done((response:any)=>{
            if (onDoneCallback) onDoneCallback(response);
        })
    }
}